<template>
  <section style="position:relative">
    <v-form ref="form" v-model="valid" @submit.prevent="connectBot" lazy-validation>
      <v-card :loading="saving">
        <v-card-title>
          <span class="headline">
            Bot
            <span class="pl-3 subtitle-1">Setup</span>
          </span>
        </v-card-title>
        <v-card-text>
          <v-alert dense type="warning" v-if="errors.server">{{errors.server}}</v-alert>
          <v-container>
            <v-row>
              <v-col cols="12">
                <p>
                  Your bot token is given to you by the Telegram
                  <a
                    class="accent--text"
                    href="http://t.me/GroupBotApp_bot"
                  >@BotFather</a> bot.
                </p>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Token*"
                  hint="Your bot's token"
                  v-model="bot.token"
                  :rules="tokenRules"
                  validate-on-blur
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined type="submit">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    saving: false,
    loading: false,
    valid: false,
    errors: {
      email: ""
    },
    tokenRules: [
      v => !!v || "Token is required",
      v => (v && v.length >= 3) || "Cannot be less than 3 characters"
    ]
  }),
  created() {},
  computed: {},
  methods: {
    ...mapActions("app", ["selectedBotSet"]),
    validate() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async connectBot() {
      if (!this.validate()) return;

      try {
        this.saving = true;
        await this.bot.save();
        this.saving = false;
      } catch (error) {
        this.saving = false;
        this.valid = false;

        if (error.message.includes("unique constraint")) {
          this.errors.email = "This bot has already been connected to.";
        } else {
          this.errors.server = error.message;
        }
      }
    }
  },
  watch: {
    bot: {
      handler() {
        if (this && !this.valid) {
          this.resetValidation();
        }
      },
      deep: true
    }
  },
  props: ["bot"]
};
</script>